import { Dialog } from "@excalidraw/excalidraw/components/Dialog";
import { t } from "@excalidraw/excalidraw/i18n";
import { useDropboxBackup } from "../hooks/useDropboxBackup";
import type { CanvasMetadata } from "../data/storage";

interface DropboxBackupDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onBackupComplete?: () => void;
}

export const DropboxBackupDialog = ({
  isOpen,
  onClose,
  onBackupComplete,
}: DropboxBackupDialogProps) => {
  const { adapter, isAuthenticated, isLoading, startAuth, disconnect } =
    useDropboxBackup();

  const handleBackup = async () => {
    if (!adapter || !isAuthenticated) {
      return;
    }

    try {
      const canvases = await adapter.listCanvases();
      console.log("Backup completed. Canvases:", canvases);
      onBackupComplete?.();
      alert(`Backup berhasil! ${canvases.length} canvas ditemukan di Dropbox.`);
    } catch (error) {
      console.error("Backup failed:", error);
      alert("Backup gagal. Silakan coba lagi.");
    }
  };

  const handleRestore = async () => {
    if (!adapter || !isAuthenticated) {
      return;
    }

    try {
      const canvases = await adapter.listCanvases();
      if (canvases.length === 0) {
        alert("Tidak ada canvas untuk di-restore dari Dropbox.");
        return;
      }

      console.log("Available canvases:", canvases);
      alert(
        `${canvases.length} canvas tersedia di Dropbox. Fitur restore akan segera tersedia.`,
      );
    } catch (error) {
      console.error("Restore failed:", error);
      alert("Restore gagal. Silakan coba lagi.");
    }
  };

  if (!isOpen) {
    return null;
  }

  return (
    <Dialog onCloseRequest={onClose} title="Dropbox Backup" size="small">
      <div style={{ padding: "1rem" }}>
        {isLoading ? (
          <p>Loading...</p>
        ) : !adapter ? (
          <div>
            <p style={{ marginBottom: "1rem", color: "#dc3545" }}>
              ⚠️ Dropbox credentials not configured.
            </p>
            <p style={{ fontSize: "0.9rem", marginBottom: "1rem" }}>
              Please set <code>VITE_DROPBOX_APP_KEY</code> and{" "}
              <code>VITE_DROPBOX_APP_SECRET</code> in your <code>.env</code>{" "}
              file.
            </p>
            <p style={{ fontSize: "0.9rem" }}>
              See{" "}
              <code>excalidraw-app/DROPBOX_BACKUP_README.md</code> for setup
              instructions.
            </p>
          </div>
        ) : !isAuthenticated ? (
          <div>
            <p style={{ marginBottom: "1rem" }}>
              Hubungkan akun Dropbox Anda untuk backup otomatis canvas
              Excalidraw.
            </p>
            <button
              onClick={startAuth}
              style={{
                padding: "0.5rem 1rem",
                backgroundColor: "#0061ff",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              Hubungkan ke Dropbox
            </button>
          </div>
        ) : (
          <div>
            <p
              style={{
                marginBottom: "1rem",
                color: "green",
                fontWeight: "bold",
              }}
            >
              ✓ Terhubung ke Dropbox
            </p>
            <div style={{ display: "flex", gap: "0.5rem", marginBottom: "1rem" }}>
              <button
                onClick={handleBackup}
                style={{
                  padding: "0.5rem 1rem",
                  backgroundColor: "#0061ff",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
              >
                Backup Sekarang
              </button>
              <button
                onClick={handleRestore}
                style={{
                  padding: "0.5rem 1rem",
                  backgroundColor: "#28a745",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
              >
                Restore dari Dropbox
              </button>
            </div>
            <button
              onClick={disconnect}
              style={{
                padding: "0.5rem 1rem",
                backgroundColor: "#dc3545",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              Putuskan Koneksi
            </button>
          </div>
        )}
      </div>
    </Dialog>
  );
};
